export enum PlayerType {
  Textbooks = 'textbooks',
  Demos = 'demos',
  Infographics = 'infographics',
}
